// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import {
  makeStyles,
  tokens,
  Spinner,
  Caption1,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalXXL,
    minHeight: "160px",
    color: tokens.colorNeutralForeground3,
  },
});

export function PageLoader({ message = "Loading…" }: { message?: string }) {
  const styles = useStyles();
  return (
    <div className={styles.root} role="status" aria-label="Loading">
      <Spinner size="medium" />
      <Caption1>{message}</Caption1>
    </div>
  );
}
